// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-aXjri-Gu","dbox":"dbox-3pGWkAZL"};